module.exports = __webpack_public_path__ + "media/icons/heart-c0a3b5afd2c30f46fad4c35c93a86bb1.svg";